import { defineComponent } from 'vue'
import AgGridColumnMethodMixins from '@/Mixins/SigmaClientNew/AgGridColumnMethods'

/*
* AG Grid Column Defs here
*/
export default defineComponent({
  mixins: [AgGridColumnMethodMixins],

  data () {
    return {
      viewTransactionColumn: {
        headerName: 'Go',
        field: 'url',
        colId: 'url',
        maxWidth: 60,
        minWidth: 60,
        editable: false,
        sortable: false,
        cellRenderer: (params) => params.data ? this.buildTransLink(params.data) : '',
        valueSetter: () => null
      },
      transNumberColumn: {
        headerName: 'Trans#',
        field: 'transNumber',
        colId: 'transNumber',
        maxWidth: 110,
        minWidth: 50,
        editable: false,
        sortable: true,
        valueGetter: (params) => {
          return params.data ? `${params.data.trans_number} (${params.data.trans_type})` : ''
        },
        valueSetter: () => null
      },
      transTypeColumn: {
        headerName: 'Type',
        field: 'transType',
        colId: 'transType',
        maxWidth: 60,
        minWidth: 20,
        editable: false,
        sortable: true,
        valueGetter: (params) => (params.data ? params.data.trans_type : ''),
        valueSetter: () => null
      },

      amountColumn: {
        headerName: 'Amount',
        field: 'amount',
        colId: 'amount',
        maxWidth: 120,
        minWidth: 40,
        editable: false,
        cellClass: 'amount',
        sortable: true,
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => (params.data ? params.data.amount : ''),
        valueSetter: () => null
      },

      lineDescColumn: {
        headerName: 'Line Desc',
        field: 'lineDesc',
        colId: 'lineDesc',
        maxWidth: 700,
        minWidth: 300,
        editable: false,
        sortable: true,
        valueGetter: (params) => (params.data ? params.data.line_desc : ''),
        valueSetter: () => null
      },

      periodColumn: {
        headerName: 'Per',
        field: 'period',
        colId: 'period',
        maxWidth: 60,
        minWidth: 60,
        editable: false,
        sortable: true,
        valueGetter: (params) => params.data ? params.data.transaction_period_id : '',
        valueSetter: () => null
      },

      effectiveDateColumn: {
        headerName: 'Eff Date',
        field: 'effectiveDate',
        colId: 'effectiveDate',
        maxWidth: 100,
        minWidth: 100,
        editable: false,
        sortable: true,
        valueGetter: (params) => params.data ? (params.data.transaction_effective_date || '').substring(0, 10) : '',
        valueSetter: () => null
      },

      paymentDateColumn: {
        headerName: 'Pmt Date',
        field: 'paymentDate',
        colId: 'paymentDate',
        maxWidth: 100,
        minWidth: 100,
        editable: false,
        sortable: true,
        valueGetter: (params) => params.data ? (params.data.transaction_payment_date || '').substring(0, 10) : '',
        valueSetter: () => null
      },

      accountCodeColumn: {
        headerName: 'Acct',
        field: 'account',
        colId: 'account',
        maxWidth: 120,
        minWidth: 80,
        editable: false,
        sortable: true,
        valueGetter: (params) => {
          return params.data ? params.data.account : ''
        },
        valueSetter: () => null
      },

      accountNameColumn: {
        headerName: 'Account Name',
        field: 'accountName',
        colId: 'accountName',
        maxWidth: 300,
        minWidth: 100,
        editable: false,
        sortable: true,
        valueGetter: (params) => (params.data ? params.data.account_name : ''),
        valueSetter: () => null
      },

      seriesCodeColumn: {
        headerName: 'Ser',
        field: 'series',
        colId: 'series',
        maxWidth: 70,
        minWidth: 50,
        editable: false,
        sortable: true,
        valueGetter: (params) => {
          return params.data ? params.data.series : ''
        },
        valueSetter: () => null
      },

      seriesNameColumn: {
        headerName: 'Series Name',
        field: 'seriesName',
        colId: 'seriesName',
        maxWidth: 300,
        minWidth: 100,
        editable: false,
        sortable: true,
        valueGetter: (params) => (params.data ? params.data.series_name : ''),
        valueSetter: () => null
      },

      locationCodeColumn: {
        headerName: 'Loc',
        field: 'location',
        colId: 'location',
        maxWidth: 70,
        minWidth: 50,
        editable: false,
        sortable: true,
        valueGetter: (params) => {
          return params.data ? params.data.location : ''
        },
        valueSetter: () => null
      },

      locationNameColumn: {
        headerName: 'Location Name',
        field: 'locationName',
        colId: 'locationName',
        maxWidth: 300,
        minWidth: 100,
        editable: false,
        sortable: true,
        valueGetter: (params) => (params.data ? params.data.location_name : ''),
        valueSetter: () => null
      },

      setCodeColumn: {
        headerName: 'Set',
        field: 'set',
        colId: 'set',
        maxWidth: 70,
        minWidth: 50,
        editable: false,
        sortable: true,
        valueGetter: (params) => {
          return params.data ? params.data.set : ''
        },
        valueSetter: () => null
      },

      setNameColumn: {
        headerName: 'Set Name',
        field: 'setName',
        colId: 'setName',
        maxWidth: 300,
        minWidth: 100,
        editable: false,
        sortable: true,
        valueGetter: (params) => (params.data ? params.data.set_name : ''),
        valueSetter: () => null
      },

      taxCodeColumn: {
        headerName: 'Tax Code',
        field: 'tax_code',
        colId: 'tax_code',
        maxWidth: 90,
        minWidth: 50,
        editable: false,
        sortable: true,
        valueGetter: (params) => params && params.data ? (params.data.tax_code === '1099-14' ? 'NEC-3' : params.data.tax_code) : '',
        valueSetter: () => null
      },

      tax_codeNameColumn: {
        headerName: 'Tax Code Name',
        field: 'taxCodeName',
        colId: 'taxCodeName',
        maxWidth: 300,
        minWidth: 100,
        editable: false,
        sortable: true,
        valueGetter: (params) => (params.data ? params.data.tax_code_name : ''),
        valueSetter: () => null
      },

      FF1CodeColumn: {
        headerName: 'FF1',
        field: 'FF1',
        colId: 'FF1',
        maxWidth: 80,
        minWidth: 50,
        editable: false,
        sortable: true,
        valueGetter: (params) => {
          return params.data ? params.data.free_field_1 : ''
        },
        valueSetter: () => null
      },

      FF1NameColumn: {
        headerName: 'FF1 Name',
        field: 'FF1Name',
        colId: 'FF1Name',
        maxWidth: 300,
        minWidth: 100,
        editable: false,
        sortable: true,
        valueGetter: (params) => (params.data ? params.data.free_field_1_name : ''),
        valueSetter: () => null
      },

      FF2CodeColumn: {
        headerName: 'FF2',
        field: 'FF2',
        colId: 'FF2',
        maxWidth: 80,
        minWidth: 50,
        editable: false,
        sortable: true,
        valueGetter: (params) => {
          return params.data ? params.data.free_field_2 : ''
        },
        valueSetter: () => null
      },

      FF2NameColumn: {
        headerName: 'FF2 Name',
        field: 'FF2Name',
        colId: 'FF2Name',
        maxWidth: 300,
        minWidth: 100,
        editable: false,
        sortable: true,
        valueGetter: (params) => (params.data ? params.data.free_field_2_name : ''),
        valueSetter: () => null
      },

      FF3CodeColumn: {
        headerName: 'FF3',
        field: 'FF3',
        colId: 'FF3',
        maxWidth: 80,
        minWidth: 50,
        editable: false,
        sortable: true,
        hide: true,
        valueGetter: (params) => {
          return params.data ? params.data.free_field_3 : ''
        },
        valueSetter: () => null
      },

      FF3NameColumn: {
        headerName: 'FF3 Name',
        field: 'FF3Name',
        colId: 'FF3Name',
        maxWidth: 300,
        minWidth: 100,
        editable: false,
        sortable: true,
        hide: true,
        valueGetter: (params) => (params.data ? params.data.free_field_3_name : ''),
        valueSetter: () => null
      },

      FF4CodeColumn: {
        headerName: 'FF4',
        field: 'FF4',
        colId: 'FF4',
        maxWidth: 80,
        minWidth: 50,
        editable: false,
        sortable: true,
        hide: true,
        valueGetter: (params) => {
          return params.data ? params.data.free_field_4 : ''
        },
        valueSetter: () => null
      },

      FF4NameColumn: {
        headerName: 'FF4 Name',
        field: 'FF4Name',
        colId: 'FF4Name',
        maxWidth: 300,
        minWidth: 100,
        editable: false,
        sortable: true,
        valueGetter: (params) => (params.data ? params.data.free_field_4_name : ''),
        valueSetter: () => null
      },

      companyCodeColumn: {
        headerName: 'Company',
        field: 'company',
        colId: 'company',
        maxWidth: 80,
        minWidth: 50,
        editable: false,
        sortable: true,
        valueGetter: (params) => {
          return params.data ? params.data.company : ''
        },
        valueSetter: () => null
      },

      companyNameColumn: {
        headerName: 'Company Name',
        field: 'companyName',
        colId: 'companyName',
        maxWidth: 300,
        minWidth: 100,
        editable: false,
        sortable: true,
        valueGetter: (params) => (params.data ? params.data.company_name : ''),
        valueSetter: () => null
      },

      productionCodeColumn: {
        headerName: 'Production',
        field: 'production',
        colId: 'production',
        maxWidth: 80,
        minWidth: 50,
        editable: false,
        sortable: true,
        valueGetter: (params) => {
          return params.data ? params.data.production : ''
        },
        valueSetter: () => null
      },

      productionNameColumn: {
        headerName: 'Production Name',
        field: 'productionName',
        colId: 'productionName',
        maxWidth: 300,
        minWidth: 100,
        editable: false,
        sortable: true,
        valueGetter: (params) => (params.data ? params.data.production_name : ''),
        valueSetter: () => null
      },

      vendorCodeColumn: {
        headerName: 'Vendor',
        field: 'vendor',
        colId: 'vendor',
        maxWidth: 200,
        minWidth: 100,
        editable: false,
        sortable: true,
        valueGetter: (params) => {
          return params.data ? params.data.transaction_vendor : ''
        },
        valueSetter: () => null
      },

      vendorNameColumn: {
        headerName: 'Vendor Name',
        field: 'vendorName',
        colId: 'vendorName',
        maxWidth: 300,
        minWidth: 100,
        editable: false,
        sortable: true,
        valueGetter: (params) => (params.data ? params.data.transaction_vendor_name : ''),
        valueSetter: () => null
      }
    }
  }
})
